export default "/images/48f6eb03857ad9fda128916871fead74.avif";